<script>
  import { currentExhibitions, pastExhibitions } from "./exhibitions";
</script>

<div class="page">
  <h1 class="page-title">Exhibitions</h1>

  {#if currentExhibitions.length}
    <h2 class="section">Recent</h2>
    {#each currentExhibitions as show}
      <a class="show" href={show.url} target="_new">
        <div class="show-title">{show.title}</div>
        <div class="show-venue">{show.venue}, {show.location}</div>
        <div class="show-dates">{show.dates}</div>
        <div class="show-info">{show.description}.</div>
        {#if show.address}
          <div class="show-address">{show.address}</div>
        {/if}
      </a>
    {/each}
  {/if}

  {#if pastExhibitions.length}
    <h2 class="section">Past</h2>
    {#each pastExhibitions as show}
      <div class="show past">
        <div class="show-title">{show.title}</div>
        <div class="show-venue">{show.venue}, {show.location}</div>
        <div class="show-dates">{show.dates}</div>
      </div>
    {/each}
  {/if}
</div>

<style>
  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem 2rem 10rem 2rem;
  }

  .page-title {
    font-family: "Cormorant Garamond", serif;
    font-weight: 400;
    font-size: 2.6rem;
    line-height: 1;
    color: #1a1a1a;
    margin: 1rem 0 1.5rem 0;
  }

  .section {
    font-family: "Cormorant Garamond", serif;
    font-style: italic;
    font-size: 1.25rem;
    font-weight: 400;
    color: #999;
    margin: 2.5rem 0 0.5rem 0;
  }

  .show {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 1.5rem 2rem;
    color: #666;
    text-align: center;
    text-decoration: none;
    max-width: 40rem;
  }
  .show .show-title {
    font-family: "Cormorant Garamond", serif;
    font-style: italic;
    font-size: 2.2rem;
    line-height: 1;
    color: var(--accent);
  }
  .show.past .show-title {
    color: #333;
  }
  .show .show-venue {
    font-size: 1rem;
    color: #333;
  }
  .show .show-dates {
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.12em;
  }
  .show .show-info {
    font-size: 0.95rem;
  }
  .show .show-address {
    font-size: 0.85rem;
    color: #999;
  }
</style>
